<div class="wrapper flex flex-col main-bg">
  @if(showNavToolbar){
  <app-nav-toolbar></app-nav-toolbar>
  }
  <div class="flex-grow main-bg" [ngClass]="{ 'top-margin': showNavToolbar }">
    <router-outlet></router-outlet>
  </div>
  <!-- <app-footer></app-footer> -->
</div>
